import { DateTime } from 'luxon';

import { TripSummaryDefaultTextDisplay } from './TripSummaryDefaultTextDisplay';

export function TripSummaryOccuredAt({ occuredAt }: { occuredAt: string }) {
  const isOlderThanOneYear =
    DateTime.now().diff(DateTime.fromISO(occuredAt), ['years']).years > 1;
  const format = isOlderThanOneYear ? 'LLLL d, yyyy h:mm a' : 'LLLL d, h:mm a';

  return (
    <TripSummaryDefaultTextDisplay
      text={DateTime.fromISO(occuredAt).toFormat(format)}
    />
  );
}
